import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const db2TableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.db2.datasetType,
    displayName: stringResources.Db2_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.db2.linkedServiceType],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-DB2'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    splitTablePath: true,
    category: ['Database'],
    copyJob: {
        multipleQuery: true
    }
};
